import styled from 'styled-components';

export const ReportToast = styled.div`
  display: flex;
  align-items: center;
`;

export const ReportTextContainer = styled.div`
  text-align: left;
  display: inline-block;
  margin-left: 10px;
  line-height: 16px;
`;

export const ReportTitle = styled.span`
  font-weight: bold;
  display: block;
`;

export const ReportInfo = styled.span`
  font-size: 10px;
`;
